import _ from 'lodash';
import { t } from '@lingui/macro';

import { dateTimeFormatter } from '../../../utilities/FormattingUtilities';

export const title = t`Time`;

export default function DateTimeFilterStateServiceFactory(filterId) {
    const DateTimeFilterStateService = {
        /*
         * Factory functions
         */

        createWithEncodedState(encodedState) {
            return DateTimeFilterStateService.decode(encodedState);
        },

        createWithDefaultState() {
            return new Date();
        },

        createState(encodedFilterState, dataService) {
            const encodedState = encodedFilterState?.[filterId];
            return encodedState
                ? this.createWithEncodedState(encodedState, dataService)
                : this.createWithDefaultState(dataService);
        },

        /*
         * Transformation functions
         */

        encode(state) {
            // eslint-disable-next-line no-param-reassign
            if (!_.isDate(state)) state = DateTimeFilterStateService.decode(state);

            return `${state.getTime()}`;
        },

        decode(encodedState) {
            return new Date(parseInt(encodedState, 10));
        },

        parameterize(state) {
            return {
                time: DateTimeFilterStateService.encode(state),
            };
        },

        summarize(state) {
            const value = dateTimeFormatter(state);

            return {
                title,
                value,
                shortValue: value,
            };
        },
    };

    return DateTimeFilterStateService;
}
